import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import bginspection from '../../assets/images/Group 1321314664 (3).webp'
import bgtrading from '../../assets/images/Group 1321314667.webp'
import { Link } from 'react-router-dom'
import { forward, inspection, trading } from './Forwarding'


const Servicebanner = () => {
  const { name } = useParams();
  const [serviceData, setServiceData] = useState(forward);
  console.log('service_data', serviceData)
  useEffect(() => {
    switch (name) {
      case "forwarding":
        setServiceData(forward);
        break;
      case "inspection":
        setServiceData(inspection);
        break;
      case "trading":
        setServiceData(trading);
        break;
      default:
        setServiceData(forward);
    }
  }, [name]);
  return (
    <div>

      <section className="overflow-hidden">
        <div className='bg-overall'>

          <div className="container">
            <div className={`${name}_class`}>
              <div className="servicehome" data-aos="zoom-in" data-aos-duration="1000">
                <h1 className="serviceborder">Our Services</h1>
              </div>
            </div>

            <div className="text-center">
              <Link to={`/Service/${name}?id=datanav`} className="text-decoration-none">
                <img src={serviceData.image} className="forwardimg" alt='.' />
              </Link>
            </div>

            <div className="container">
              <div className="forwardheader mt-5">
                <h1 data-aos="zoom-in " data-aos-duration="1000">
                  {serviceData.heading}
                </h1>
                <p className="mt-4" data-aos="fade-right" data-aos-duration="1000">
                  {serviceData.content}
                </p>
              </div>
            </div>
            {serviceData.data.map((item, index) => (
              <div className="" key={index}>
                {/* <div className="container" > */}
                <div className="row forwardpy align-items-center" id="datanav">
                  {/* {index % 2 === 0 ? (
                    <>
                      <div className="col-lg-6 col-md-12 col-12 mobgrid" data-aos="fade-left" data-aos-duration="1000">
                        <img src={item.cardimage} className="cardservice" alt=".." />
                      </div>
                      <div className="col-lg-6 col-md-12 servicegrid">
                        <div className="dropheader" data-aos="zoom-in" data-aos-duration="1000">
                          {item.title}
                          <div className="droppara py-3" data-aos="fade-right" data-aos-duration="1000">
                            {item.description}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-lg-6 col-md-12 servicegrid">
                        <div className="dropheader" data-aos="zoom-in" data-aos-duration="1000">
                          {item.title}
                          <div className="droppara py-3" data-aos="fade-left" data-aos-duration="1000">
                            {item.description}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-12 mobgrid" data-aos="fade-right" data-aos-duration="1000">
                        <img src={item.cardimage} className="cardservice" alt=".." />
                      </div>
                    </>
                  )} */}

                  <>
                    <div className={` col-lg-6 col-md-12 col-12 mobgrid ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`} data-aos="fade-left" data-aos-duration="1000">
                      <img src={item.cardimage} className="cardservice" alt=".." />
                    </div>
                    <div className={`col-lg-6 col-md-12 servicegrid ${index % 2 !== 0 ? 'order-lg-1' : 'order-lg-2'}`}>
                      <div className="dropheader" data-aos="zoom-in" data-aos-duration="1000">
                        {item.title}
                        <div className="droppara py-3" data-aos="fade-right" data-aos-duration="1000">
                          {item.description}
                        </div>
                      </div>
                    </div>
                  </>
                </div>
                {/* </div> */}
              </div>
            ))}

          </div>
        </div>

      </section>

    </div>
  )
}

export default Servicebanner
